import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
} from 'react-admin';

const FeaturedItemEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="order" />
    </SimpleForm>
  </Edit>
);

export default FeaturedItemEdit;
